import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

export default function AdminRoles() {
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    api.get("/admin/roles").then((r) => setRoles(r.data)).catch(() => setRoles([]));
  }, []);
  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Permissions</div>
        <h1 className="headline-xl">Role catalog</h1>
        <p className="text-lifted-dim mt-2 text-sm max-w-2xl">
          Permissions are additive — a user with multiple roles gains the union of every permission below.
        </p>
      </header>

      <div data-testid={ADMIN.rolesCatalog} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {roles.map((r, i) => (
          <div key={r.key} className={`glass-panel p-5 fade-up delay-${(i % 5) + 1}`}>
            <div className="flex items-center justify-between">
              <div className="font-anton text-xl uppercase">{r.label}</div>
              <code className="text-[0.65rem] text-lifted-mute">{r.key}</code>
            </div>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {r.permissions.map((p) => (
                <code key={p} className="chip !text-[0.65rem] !tracking-[0.1em] font-manrope normal-case text-lifted-text">{p}</code>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
